export enum BrandNameList {
  LC = 'LC',
  TO = 'TO',
}

export enum BrandNameLabelList {
  LC = 'Lenscrafters',
  TO = 'Target Optical',
}
